import { CancelTokenSource } from 'axios'
import { ErrorUtils } from '@/commons/utils/error'
import { Address } from '@/store/entities/application'
import { AddressResponse } from '@/commons/types/address'
import { ENVIRONMENT } from '@/commons/configuration'
import authenticatedAxios from '@/commons/configuration/authenticated.axios'
import {
    emptyConfigRequest
} from '@/commons/configuration/un.authenticated.axios'

export class AddressService {
    static async fetchPostalCode (addressId: string, cancelToken: CancelTokenSource): Promise<string> {
        try {
            const response = await emptyConfigRequest.get(ENVIRONMENT.postalCodeRequestUrl, {
                params: {
                    adr_id: addressId
                },
                cancelToken: cancelToken.token
            })
            return response.data
        } catch (e) {
            ErrorUtils.requestErrorHandler(e)
            return ''
        }
    }

    static async fetchAddresses (searchText: string, cancelToken: CancelTokenSource): Promise<Array<Address>> {
        try {
            const response: { data: AddressResponse } = await authenticatedAxios.get(ENVIRONMENT.geoServiceUrl, {
                params: {
                    term: searchText
                },
                cancelToken: cancelToken.token
            })
            return response.data.list && response.data.list.length > 0 && response.data.list[0].id !== ''
                ? response.data.list.map(address =>
                    new Address(Number(address.id), address.kood, address.taisaadress, address.sihtnumber))
                : []
        } catch (e) {
            ErrorUtils.requestErrorHandler(e)
            return []
        }
    }
}
